var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H12V14.5C12 14.7083 11.9609 14.9036 11.8828 15.0859C11.8047 15.2682 11.6979 15.4271 11.5625 15.5625C11.4271 15.6979 11.2682 15.8047 11.0859 15.8828C10.9036 15.9609 10.7083 16 10.5 16H2.5C2.29167 16 2.09635 15.9609 1.91406 15.8828C1.73177 15.8047 1.57292 15.6979 1.4375 15.5625C1.30208 15.4271 1.19531 15.2682 1.11719 15.0859C1.03906 14.9036 1 14.7083 1 14.5V3H0V2H4V1C4 0.859375 4.02604 0.729167 4.07812 0.609375C4.13021 0.489583 4.20052 0.385417 4.28906 0.296875C4.38281 0.203125 4.48958 0.130208 4.60938 0.078125C4.72917 0.0260417 4.85938 0 5 0H8C8.14062 0 8.27083 0.0260417 8.39062 0.078125C8.51042 0.130208 8.61458 0.203125 8.70312 0.296875C8.79688 0.385417 8.86979 0.489583 8.92188 0.609375C8.97396 0.729167 9 0.859375 9 1V2H13V3ZM5 2H8V1H5V2ZM11 3H2V14.5C2 14.6354 2.04948 14.7526 2.14844 14.8516C2.2474 14.9505 2.36458 15 2.5 15H10.5C10.6354 15 10.7526 14.9505 10.8516 14.8516C10.9505 14.7526 11 14.6354 11 14.5V3ZM5 13H4V5H5V13ZM7 13H6V5H7V13ZM9 13H8V5H9V13Z",
    fill: "#205493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5a7d383832e1063f72a8a3868d901ba7.svg";
export { ForwardRef as ReactComponent };